module.exports = __webpack_public_path__ + "static/img/0002-A-01.aacc87f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0002-A-01.jpg
// module id = AeYp
// module chunks = 0